import addMount from "../../core/addMount";
import FavoritesList from "./FavoritesList.entry";

addMount({ appName: "favorites-list", app: FavoritesList });
